/* jshint esversion: 6 */
/* jshint -W033 */
/**
 * 存储localStorage
 */
export const setStore = (name, data, day) => {
  if (!name) return
  let days = day || 7
  let exp = new Date()
  let content = JSON.stringify({
    access: data.access,
    refresh: data.refresh,
    expire: exp.getTime() + 60000
  })
  console.log('setStore:' + content)
  window.localStorage.setItem(name, content)
}

/**
 * 获取localStorage
 */
export const getStore = name => {
  if (!name) return
  console.log('getStore:' + window.localStorage.getItem(name))
  let o = JSON.parse(window.localStorage.getItem(name))
  if (!o || o.expire < Date.now()) {
    return null
  } else {
    return o
  }
}

/**
 * 删除localStorage
 */
export const removeStore = name => {
  if (!name) return
  window.localStorage.removeItem(name)
}

/**
 * 存放SessionStorage
 */
export const setSessionStore = (name, value) => {
  if (!name) return
  window.sessionStorage.setItem(name, value)
}

/**
 * 获取SessionStorage
 */
export const getSessionStore = name => {
  if (!name) return
  return window.sessionStorage.getItem(name)
}

/**
 * 删除SessionStorage
 */
export const removeSessionStore = name => {
  if (!name) return
  window.sessionStorage.removeItem(name)
}
